import React from "react";
import Marquee from "react-fast-marquee";

// Small, premium football/betting ticker used in the hero header row.
// Kept intentionally lightweight so it stays elegant next to the overline.
const items = [
  { type: "icon" },
  { type: "chip", label: "1", tone: "red" },
  { type: "chip", label: "X", tone: "muted" },
  { type: "chip", label: "2", tone: "red" },
  { type: "pair", k: "GS – FB", v: "1.95" },
  { type: "sep" },
  { type: "pair", k: "AH", v: "-1.5" },
  { type: "pair", k: "O/U", v: "2.5" },
  { type: "pair", k: "BTTS", v: "YES" },
  { type: "sep" },
  { type: "icon" },
  { type: "chip", label: "1X", tone: "muted" },
  { type: "chip", label: "X2", tone: "muted" },
];

const BallIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
    className="shrink-0"
  >
    <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.55)" strokeWidth="1.4" />
    <path
      d="M12 2 L14.5 6.5 L20 8 L16 12 L17 18 L12 15.5 L7 18 L8 12 L4 8 L9.5 6.5 Z"
      fill="rgba(227,10,23,0.9)"
      stroke="rgba(255,255,255,0.3)"
      strokeWidth="0.6"
    />
  </svg>
);

const Chip = ({ label, tone }) => (
  <span
    className={`inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 text-[10px] font-bold tracking-[0.05em] ${
      tone === "red"
        ? "bg-[var(--hk-red)] text-white"
        : "border border-white/25 text-white/80"
    }`}
  >
    {label}
  </span>
);

const Pair = ({ k, v }) => (
  <span className="inline-flex items-center gap-2">
    <span className="text-[10px] tracking-[0.2em] text-white/45 font-semibold uppercase">
      {k}
    </span>
    <span className="font-mono text-[11px] text-white font-semibold">{v}</span>
  </span>
);

const Sep = () => (
  <span className="inline-block w-1 h-1 bg-[var(--hk-red)]" aria-hidden />
);

const HeroTicker = () => {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="hero-ticker"
      className="relative w-full overflow-hidden border-y border-white/10 bg-black/40 backdrop-blur-sm"
    >
      {/* fade edges */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 left-0 w-10 z-10"
        style={{
          background: "linear-gradient(to right, var(--hk-bg), transparent)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 right-0 w-10 z-10"
        style={{
          background: "linear-gradient(to left, var(--hk-bg), transparent)",
        }}
      />
      <Marquee gradient={false} speed={38} pauseOnHover>
        <div className="flex items-center gap-5 py-2.5 pl-5">
          {doubled.map((it, i) => (
            <span key={i} className="inline-flex items-center">
              {it.type === "icon" && <BallIcon />}
              {it.type === "chip" && <Chip label={it.label} tone={it.tone} />}
              {it.type === "pair" && <Pair k={it.k} v={it.v} />}
              {it.type === "sep" && <Sep />}
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
};

export default HeroTicker;
